import experiencesData from '../data/experiences.json';
import rolesData from '../data/roles.json';
import companiesData from '../data/companies.json';
import technologiesData from '../data/technologies.json';
import expTechData from '../data/experience_technologies.json';

import { WorkExperience } from '../models/work.experience.interface';
import { Role } from '../models/role.interface';
import { Company } from '../models/company.interface';
import { Technology } from '../models/technology.interface';

// new Date("YYYY-MM-DD") is parsed as UTC midnight, which shifts to the previous
// month in negative-offset time zones (e.g. Argentina). Build a local date instead.
function parseLocalDate(value: string): Date {
    const [year, month] = value.split('-').map(Number);
    return new Date(year, month - 1, 1);
}

export class WorkExperiencesService {
    private workExperiences: WorkExperience[] = [];

    constructor() {
        const roles = rolesData.roles as any[];
        const companies = companiesData.companies as Company[];
        const technologies = technologiesData.technologies as Technology[];

        this.workExperiences = experiencesData.experiences.map((exp: any) => {
            const company = companies.find(c => c.id === exp.company_id)!;
            const role = roles.find(r => r.id === exp.role_id) as Role;

            const techLinks = expTechData.experience_technologies.filter(et => et.experience_id === exp.id);
            const expTechnologies: Technology[] = [];
            techLinks.forEach(link => {
                const found = technologies.find(t => t.id === link.technology_id);
                if (found) expTechnologies.push(found);
            });

            return {
                id: exp.id,
                description: exp.description,
                bullets: exp.bullets,
                start_date: parseLocalDate(exp.start_date),
                end_date: exp.end_date ? parseLocalDate(exp.end_date) : null,
                company,
                role,
                technologies: expTechnologies,
            } as WorkExperience;
        });
    }

    getWorkExperiences(): WorkExperience[] {
        return this.workExperiences;
    }
}

export const workExperiencesService = new WorkExperiencesService();
